import "phaser";
import { GetScalingInfo } from './Utils/HelperFunction';

export class Game {
	public phaserInstance;

	constructor(config: Phaser.Types.Core.GameConfig) {
		this.phaserInstance = new Phaser.Game(config);

		window.addEventListener('resize', event => {
			setTimeout(() => {
				let scalingInfo = GetScalingInfo();
				for (let i = 0; i < this.phaserInstance.scene.scenes.length; i++) {
					if (this.phaserInstance.scene.scenes[i] && this.phaserInstance.scene.scenes[i].resize)
						this.phaserInstance.scene.scenes[i].resize(scalingInfo);
				}
			}, 100);

			setTimeout(() => {
				document.documentElement.style.height = `100%`;
				setTimeout(() => {
					// this line prevents the content
					// from hiding behind the address bar
					window.scrollTo(0, 1);
				}, 500);
			}, 500);
		});
	}
}
